import React from "react";
import { useTranslation } from "react-i18next";

function Deadline({ children, orderStatus }) {
  const { t, i18n } = useTranslation();

  if (orderStatus === "success" || orderStatus === "failed" || orderStatus === "archive") {
    return (
      <div className="bg-gradient-to-r  from-vistagrey/40 to-vistagrey/20 text-vistagrey font-bold rounded-full text-center text-small h-7 items-center leading-7">
        ---
      </div>
    );
  }

  // Check if children is NaN
  if (isNaN(children)) {
    return (
      <div className="bg-gradient-to-r from-red-700 to-red-500 text-white font-bold rounded-full text-center text-small h-7 items-center leading-7">
        {t("undefined")}
      </div>
    );
  }
  const totalMinutes = Math.abs(children);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const now = new Date();
  const targetDate = new Date(now.getTime() + totalMinutes * 60000 * Math.sign(children));
  const formattedDate = targetDate.toLocaleDateString(i18n.language, {
    weekday: "long", 
    day: "numeric", 
    month: "short" 
  });

  // Fonction pour gérer le pluriel
  // TODO : a exporter dans utils
  const pluralize = (count, singular, plural) =>
    count === 1 ? singular : plural;

  let formattedTime;

  let colorStatus = children > 30 ? "green" : children > 15 ? "orange" : "red";

  if (children > 0) {
    // Deadline not yet reached
    if (totalMinutes >= 1440) {
      formattedTime = `${formattedDate}`;
    } else if (totalMinutes >= 60) {
      formattedTime = `${t("remaining")} ${hours.toString().padStart(2, "0")} ${pluralize(
        hours,
        t("hour_singular"),
        t("hour_plural"),
      )} ${minutes.toString().padStart(2, "0")} ${pluralize(
        minutes,
        t("minute_singular"),
        t("minute_plural"),
      )}`;
    } else {
      formattedTime = `${t("remaining")} ${minutes} ${pluralize(minutes, t("minute_singular"), t("minute_plural"))}`;
    }
  } else {
    // Deadline exceeded
    if (totalMinutes >= 1440) {
      formattedTime = `${t("late")} : ${days} ${pluralize(
        days,
        t("day_singular"),
        t("day_plural"),
      )} ${hours.toString().padStart(2, "0")} ${pluralize(hours, t("hour_singular"), t("hour_plural"))}`;
    } else if (totalMinutes >= 60) {
      formattedTime = `${t("late")} : ${hours
        .toString()
        .padStart(2, "0")} ${pluralize(hours, t("hour_singular"), t("hour_plural"))} ${minutes
        .toString()
        .padStart(2, "0")} ${pluralize(minutes, t("minute_singular"), t("minute_plural"))}`;
    } else {
      formattedTime = `${t("late")} : ${minutes} ${pluralize(
        minutes,
        t("minute_singular"),
        t("minute_plural"),
      )}`;
    }
  }

  return (
    <div
      className={`${
        colorStatus === "red"
          ? "bg-gradient-to-r from-red-700 to-red-500 text-white"
          : colorStatus === "orange"
            ? "bg-gradient-to-r from-orange-600 to-orange-400 text-white"
            : "bg-gradient-to-r from-vistactagreen/40 to-vistactagreen/20 text-vistactagreen"
      } font-bold rounded-full text-center text-xs h-7 items-center leading-7 capitalize px-2 whitespace-nowrap`}
    >
      {formattedTime}
    </div>
  );
}

export default Deadline;